import {FEATURE_FLAGS} from '@/constants';
import {hasFeatureFlag, isGenAiDisabled} from '../../util/FeatureUtil';
import {hasPermission} from '../../util/PermissionsUtil';
import type {AgentDeclaration} from './agentDeclaration';

const deployedAgentIds = new Set<string>();

export const setDeployedAgentIds = (agentIds: string[]): void => {
	deployedAgentIds.clear();
	agentIds.forEach(agentId => deployedAgentIds.add(agentId));
};

export const isAgentDeployed = (agentId: string): boolean => deployedAgentIds.has(agentId);

export const canSeeAgent = (declaration: AgentDeclaration): boolean =>
	hasFeatureFlag(FEATURE_FLAGS.NOVA_AGENTIC_WORKFLOWS) &&
	!isGenAiDisabled() &&
	hasPermission(declaration.permission) &&
	isAgentDeployed(declaration.id);
